import { loadNaturalEarthAdm0 } from "./loadNaturalEarthAdm0";
import type { MapData } from "../types";
import type { NaturalEarthProps } from "./loadNaturalEarthAdm0";

const EUROPE_ADM0_A3 = new Set([
  "ALB",
  "AND",
  "ARM",
  "AUT",
  "AZE",
  "BEL",
  "BGR",
  "BIH",
  "BLR",
  "CHE",
  "CYP",
  "CZE",
  "DEU",
  "DNK",
  "ESP",
  "EST",
  "FIN",
  "FRA",
  "GBR",
  "GEO",
  "GRC",
  "HRV",
  "HUN",
  "IRL",
  "ISL",
  "ITA",
  "LIE",
  "LTU",
  "LUX",
  "LVA",
  "MCO",
  "MDA",
  "MKD",
  "MLT",
  "MNE",
  "NLD",
  "NOR",
  "POL",
  "PRT",
  "ROU",
  "RUS",
  "SMR",
  "SRB",
  "SVK",
  "SVN",
  "SWE",
  "TUR",
  "UKR",
  "VAT",
  "KOS",
]);

export async function loadEuropeAdm0(): Promise<MapData> {
  return loadNaturalEarthAdm0((props: NaturalEarthProps) =>
    EUROPE_ADM0_A3.has(props.ADM0_A3),
  );
}
